var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconMembership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.047,
    height: 21.962,
    viewBox: "0 0 21.047 21.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.915 8.236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.759,192h-18.3a.458.458,0,0,0-.458.458v12.811a.458.458,0,0,0,.458.458h18.3a.458.458,0,0,0,.458-.458V192.458A.458.458,0,0,0,50.759,192ZM50.3,204.811H32.915v-11.9H50.3v11.9Z",
    transform: "translate(-32 -192)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.255,106.667H11.124a.458.458,0,0,0-.458.458v3.66a.458.458,0,0,0,.458.458H31.255a.458.458,0,0,0,.458-.458v-3.66A.458.458,0,0,0,31.255,106.667Zm-.458,3.66H11.581v-2.745H30.8Z",
    transform: "translate(-10.666 -106.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.066 4.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M245.791,106.667a.458.458,0,0,0-.458.458V123.6a.458.458,0,1,0,.915,0V107.125A.458.458,0,0,0,245.791,106.667Z",
    transform: "translate(-245.333 -106.667)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.66 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M103.331,4.925c-.47-2.206-3.276-4.574-5.145-4.89A1.83,1.83,0,0,0,96,1.83a1.837,1.837,0,0,0,.415,1.16A.054.054,0,0,1,96.424,3c1.359,1.736,5.882,2.4,6.4,2.472a.486.486,0,0,0,.062,0,.458.458,0,0,0,.448-.553Zm-6.2-2.5a.309.309,0,0,0-.027-.032.9.9,0,0,1-.19-.558A.916.916,0,0,1,97.83.915a1.038,1.038,0,0,1,.19.019,7.044,7.044,0,0,1,4.186,3.512C100.614,4.153,97.924,3.467,97.132,2.42Z",
    transform: "translate(-96)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.047 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.4,0a1.8,1.8,0,0,0-.342.032c-1.881.319-4.687,2.687-5.157,4.893a.458.458,0,0,0,.448.553c.02,0,.041,0,.061,0,.514-.07,5.037-.736,6.4-2.472l.01-.012A1.83,1.83,0,0,0,250.4,0Zm.725,2.389a.311.311,0,0,0-.027.032c-.792,1.045-3.481,1.732-5.075,2.026a7.043,7.043,0,0,1,4.2-3.515A.95.95,0,0,1,250.4.915a.915.915,0,0,1,.725,1.474Z",
    transform: "translate(-244.886)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembership);
export default __webpack_public_path__ + "static/media/icon-membership.71c32155bd634c850a79e50d6bac20c0.svg";
export { ForwardRef as ReactComponent };